import { useMsal } from '@azure/msal-react';
import DateFnsUtils from '@date-io/date-fns';
import { Button, IconButton, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, Grid, Paper, TextField, Typography, Checkbox, TableContainer, CircularProgress, Link, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab';
import { KeyboardArrowRight } from "@material-ui/icons";
import { KeyboardDateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { de } from "date-fns/locale";
import React, { ReactElement, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { globalStyles } from '../../assets/globalStyles';
import { validate, validateHelper } from '../../features/validate/validate';
import { gespeicherteSuche, messgroesse, stoerung } from '../../utils/apiTypes'
import {
    startNewEntry, discardChanges, discardNew, getMessstellen, resetError, resetViewMode,
    selectEditDirty, selectEditEntry, selectError, selectNewEntry,
    selectMessstellen, selectViewMode, setEditEntry, setEndDatum, setError, setKommentar,
    setStartDatum, setMessstelle, getStoerungen, updateAktuelleStoerung, deleteStoerung,
    selectStoerungsliste, selectAktuelleStoerung, createStoerung, updateStoerung, setName, stoerungDummy, selectStoerschrieblisteLoading,
    selectAnhanglisteLoading, selectGraphenlisteLoading, selectStoerungslisteLoading, getGespeicherteSuchen, selectGespeicherteSuchen,
    addGraphToAktuellerStoerung, removeGraphFromAktuellerStoerung, loadGraphen, loadStoerschriebe, getAnhang, deleteAnhang, addAnhang, selectMesssstellenLoading, exportStoerschriebeToExcel, selectExportLoading, selectSorting, setSorting
} from './stoerungsmanagementSlice';
import { useStyles } from './stoerungsmanagementStyles';
import { messstelle } from './../../utils/apiTypes';
import { DataGrid, deDE, GridCellParams, GridColDef, GridSortModel, GridValueFormatterParams, GridValueGetterParams, LocalizationV4 } from '@material-ui/data-grid';
import { emptyTab, loadGespeicherteSuche } from '../netzwirtschaft/netzwirtschaftSlice';
import { useHistory, useParams } from 'react-router';
import { Delete } from '@material-ui/icons';
import { nanosecondsTimeStampToLocalString, nanosecondsTimeStampToUTCString, toUTCDateString, addTimezoneOffset, subtractTimezoneOffset, alphaNumSort } from './../../utils/utils';
import { selectDate } from "../../features/konfiguration/konfigurationSlice";
import { isAuthorized, rollen } from '../../utils/auth/authConfig';
import { getMessstellenForLookup, getMessstellenLookup, selectMessstellenLoadingLookup, selectMessstellenDictionary } from '../../features/messstellenLookup/messstellenLookupSlice';

export default function Stoerungsmanagement(): ReactElement {

    const dispatch = useAppDispatch();

    const { instance } = useMsal();

    const { id } = useParams<{id: string | undefined}>();

    useEffect(() => {
        dispatch(getMessstellen());
        dispatch(getStoerungen(id));
        dispatch(getGespeicherteSuchen());
        dispatch(getMessstellenForLookup());
    }, [instance]);

    const classes = {
        ...useStyles(),
        ...globalStyles(),
    };

    const history = useHistory();

    const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false);

    const [openFileUploadDialog, setOpenFileUploadDialog] = React.useState(false);

    const [selectedFile, setSelectedFile] = React.useState<File | null>(null);
    const selectFile = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event && event.target && event.target.files) {
            setSelectedFile(event.target.files[0]);
        }
    }

    const uploadSelectedFile = () => {
        if (selectedFile) {
            setOpenFileUploadDialog(false);
            dispatch(addAnhang(aktuelleStoerung.id, selectedFile));
            setSelectedFile(null);
        }
    }

    const
        aktuelleStoerung = useAppSelector(selectAktuelleStoerung),
        stoerungsliste = useAppSelector(selectStoerungsliste),
        editEntry: boolean = useAppSelector(selectEditEntry),
        newEntry: boolean = useAppSelector(selectNewEntry),
        viewMode: boolean = useAppSelector(selectViewMode),
        dirtyEdit: number = useAppSelector(selectEditDirty),
        inputError: boolean = useAppSelector(selectError),
        messstellen: Array<messstelle> = useAppSelector(selectMessstellen),
        stoerungslisteLoading: boolean = useAppSelector(selectStoerungslisteLoading),
        stoerschrieblisteLoading: boolean = useAppSelector(selectStoerschrieblisteLoading),
        graphenlisteLoading: boolean = useAppSelector(selectGraphenlisteLoading),
        anhanglisteLoading: boolean = useAppSelector(selectAnhanglisteLoading),
        messstellenLoading: boolean = useAppSelector(selectMesssstellenLoading),
        exportLoading: number = useAppSelector(selectExportLoading),
        gespeicherteSuchen: Array<gespeicherteSuche> = useAppSelector(selectGespeicherteSuchen),
        sorting: GridSortModel = useAppSelector(selectSorting);

    const messstellenDict = useAppSelector(selectMessstellenDictionary);
    const messstellenLoadingLookup = useAppSelector(selectMessstellenLoadingLookup);

    const isUTC = useAppSelector(selectDate);

    const stoerungslisteGridCols: GridColDef[] = [
        { field: 'name', headerName: 'Störungsbezeichnung', flex: 0.8 },
        {
            field: 'uw', headerName: 'UW', flex: 0.8, valueGetter: (params: GridValueGetterParams) => {
                return messstellen.length == 0 ? "Wird geladen..." : (messstellen.find((x: messstelle) => x.name == params.getValue(params.id, 'messstelle'))?.umspannwerk);
            }
        },
        {
            field: 'schaltfeld', headerName: 'Schaltfeld', flex: 0.8,
            valueGetter: (params: GridValueGetterParams) => {
                const messstellenName = String(params.getValue(params.id, "messstelle"));
                //eslint-disable-next-line security/detect-object-injection
                return messstellenDict[messstellenName] == undefined ? "Wird geladen..." : getMessstellenLookup(messstellenDict, messstellenName, "schaltfeld");
            },
        },
        { field: 'messstelle', headerName: 'Messstelle', flex: 0.5, sortComparator: alphaNumSort },
        {
            field: 'start', headerName: 'Startzeitpunkt', flex: 0.8, filterable: false, valueFormatter: (params: GridValueFormatterParams) =>
                (isUTC ? toUTCDateString(new Date(params.row.start)) : new Date(params.row.start).toLocaleString())
        },
        { field: 'ende', headerName: 'Endzeitpunkt', flex: 0.8, filterable: false, valueFormatter: (params: GridValueFormatterParams) => (isUTC ? toUTCDateString(new Date(params.row.ende)) : new Date(params.row.ende).toLocaleString()) },
        {
            field: 'zugeordneteStoerschriebe', headerName: 'Zugeordnete Störschriebe', filterable: false, flex: 0.8, sortable: false,
            renderCell: function actions(params: GridCellParams) {
                return <IconButton color="secondary" style={{ fontSize: "medium" }}
                    onClick={() => {
                        let uw = "";
                        const ms = messstellen.find((x: messstelle) => x.name == params.getValue(params.id, 'messstelle'));
                        if (ms != undefined) uw = ms.umspannwerk;
                        dispatch(loadStoerschriebe(uw, params.getValue(params.id, 'messstelle') as string, new Date(params.row.start), new Date(params.row.ende)));
                        history.push("/dashboardAnalyse");
                    }}>zur Detailansicht <KeyboardArrowRight /></IconButton>
            },
        },
        {
            field: 'zugeordneteGraphen', headerName: 'Zugeordnete Graphen', filterable: false, flex: 0.8, sortable: false,
            renderCell: function actions(params: GridCellParams) {
                return <IconButton color="secondary" style={{ fontSize: "medium" }} onClick={() => {
                    dispatch(loadGraphen(params.id as number, gespeicherteSuchen));
                    history.push("/dashboardAnalyse");
                }
                }>zur Detailansicht<KeyboardArrowRight /></IconButton>
            },
        },
        {
            field: 'download', headerName: 'Störschriebe exportieren', filterable: false, flex: 0.8, sortable: false,
            renderCell: function actions(params: GridCellParams) {
                return exportLoading == params.row.id ? <CircularProgress size="20px" color="primary" /> : <Button color="secondary"
                    onClick={() => {
                        let uw = "";
                        const ms = messstellen.find((x: messstelle) => x.name == params.getValue(params.id, 'messstelle'));
                        if (ms != undefined) uw = ms.umspannwerk;
                        dispatch(exportStoerschriebeToExcel(params.row.id, uw, params.getValue(params.id, 'messstelle') as string, new Date(params.row.start), new Date(params.row.ende)));
                    }}>Exportieren</Button >
            },
        },
    ]

    const stoerschrieblisteGridCols: GridColDef[] = [
        { field: 'datenklasse', headerName: 'Störschrieb', flex: 0.8 },
        { field: 'messstelle', headerName: 'Messstelle', flex: 0.8, sortComparator: alphaNumSort },
        { field: 'start', headerName: 'Startzeitpunkt', filterable: false, flex: 0.8, valueFormatter: (params: GridValueFormatterParams) => (isUTC ? nanosecondsTimeStampToUTCString(params.row.start) : nanosecondsTimeStampToLocalString(params.row.start)) },
        { field: 'ende', headerName: 'Endzeitpunkt', filterable: false, flex: 0.8, valueFormatter: (params: GridValueFormatterParams) => (isUTC ? nanosecondsTimeStampToUTCString(params.row.ende) : nanosecondsTimeStampToLocalString(params.row.ende)) },
    ]

    const changeZuordnung = (event: React.ChangeEvent<HTMLInputElement>, id: number) => {
        event.target.checked ? dispatch(addGraphToAktuellerStoerung(id)) : dispatch(removeGraphFromAktuellerStoerung(id));
    }

    const graphenGridCols: GridColDef[] = [
        { field: 'name', headerName: 'Name', flex: 0.6 },
        { field: 'uw', headerName: 'Umspannwerk', flex: 0.7, valueGetter: (params: GridValueGetterParams) => params.row.wert.fields.uw },
        { field: 'messpunkt', headerName: 'Messpunkt', flex: 0.7, valueGetter: (params: GridValueGetterParams) => params.row.wert.fields.messpunkt },
        { field: 'rekorder', headerName: 'Rekorder', flex: 0.7, valueGetter: (params: GridValueGetterParams) => params.row.wert.fields.rekorder.beschreibung + " - " + params.row.wert.fields.rekorder.kategorie },
        {
            field: 'messgroesse', headerName: 'Messgrößen', flex: 1, sortable: false, renderCell:
                function messgroessen(params: GridValueGetterParams) { const t = params.row.wert.fields.messgroesse.map((x: messgroesse) => x.beschreibung + " (" + x.feldname + ")").join(", "); return <span title={t}>{t}</span>; }
        },
        { field: 'start', headerName: 'Startzeitpunkt', filterable: false, flex: 0.6, valueGetter: (params: GridValueGetterParams) => (isUTC ? toUTCDateString(new Date(params.row.wert.fields.startDatum)) : new Date(params.row.wert.fields.startDatum).toLocaleString()) },
        { field: 'ende', headerName: 'Endzeitpunkt', filterable: false, flex: 0.6, valueGetter: (params: GridValueGetterParams) => (isUTC ? toUTCDateString(new Date(params.row.wert.fields.endDatum)) : new Date(params.row.wert.fields.endDatum).toLocaleString()) },
        {
            field: 'zugeordnet', headerName: 'Zugeorndet', filterable: false, flex: 0.3, sortable: false, hide: (!newEntry && !editEntry),
            renderCell: function actions(params: GridCellParams) { return <Checkbox checked={aktuelleStoerung.graphen.includes(params.id as number)} onChange={(event) => changeZuordnung(event, params.id as number)} disabled={!newEntry && !editEntry && !isAuthorized([rollen.admin, rollen.technik, rollen.netzwirtschaft])} /> }
        }
    ]

    function printTable(data: stoerung[]) {
        return (
            <Container maxWidth={false} className={classes.root}>
                <div style={{ height: "30vh" }}>
                    {stoerungslisteLoading ? <CircularProgress /> : <DataGrid
                        localeText={(deDE as LocalizationV4).props.MuiDataGrid.localeText}
                        columns={stoerungslisteGridCols}
                        rows={stoerungsliste}
                        sortModel={sorting}
                        disableColumnSelector={true}
                        onSortModelChange={(model) => setSorting(model.sortModel)}
                        onCellClick={(param: GridCellParams) => {
                            if (param.field == "zugeordneteStoerschriebe" || param.field == "zugeordneteGraphen" || param.field == "download") return false;
                            let mt = stoerungDummy;
                            const temp = data.find(mst => mst.id == (param.row.id as number))
                            if (temp)
                                mt = temp;
                            if (!editEntry)
                                dispatch(updateAktuelleStoerung(mt));
                        }}
                        loading={stoerungslisteLoading && messstellenLoadingLookup}
                        className={classes.zeroPadding} />}
                </div>
            </Container>
        )
    }

    function printSaveDiscardButtons() {
        return (<div>
            <Button
                variant="contained"
                onClick={() => { newEntry ? dispatch(createStoerung(aktuelleStoerung)) : dispatch(updateStoerung(aktuelleStoerung)) }}
                color="secondary"
                className={classes.showtriButton}
                disabled={
                    !dirtyEdit || inputError}
                style={{ minHeight: "36px" }}
            >
                {stoerungslisteLoading ? <CircularProgress size="20px" style={{ padding: "1px" }} /> : "Speichern"}
            </Button>
            <Button
                variant="contained"
                onClick={() => { newEntry ? dispatch(discardNew()) : dispatch(discardChanges()) }}
                color="secondary"
                className={classes.showtriButton}
            >
                Abbrechen
            </Button>
        </div>)
    }
    function confirmDeleteOfStoerung() {
        dispatch(deleteStoerung(aktuelleStoerung));
        setOpenDeleteDialog(false);
    }

    function printEditDeleteButton() {
        if (isAuthorized([rollen.admin, rollen.technik, rollen.netzwirtschaft]))
            return (
                <div>
                    <Button
                        variant="contained"
                        onClick={() => dispatch(setEditEntry())}
                        color="secondary"
                        className={classes.showtriButton}
                    >
                        Bearbeiten
                    </Button>
                    <Button
                        variant="contained"
                        onClick={() => setOpenDeleteDialog(true)}
                        color="secondary"
                        className={`${classes.backgroundColorErrorDark} ${classes.showtriButton}`}
                    >
                        Löschen
                    </Button>
                    <Dialog
                        open={openDeleteDialog}
                        onClose={() => setOpenDeleteDialog(false)}
                    >
                        <DialogTitle>Störung löschen</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                {'Sind Sie sicher, dass Sie die Störung "' + aktuelleStoerung.name + '" löschen wollen?'}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                color="secondary"
                                variant="contained"
                                onClick={() => setOpenDeleteDialog(false)}
                                className={classes.cancleDeleteButton}
                            >
                                Abbrechen
                            </Button>
                            <Button
                                variant="contained"
                                onClick={confirmDeleteOfStoerung}
                                className={classes.confirmDeleteButton}
                            >
                                {stoerungslisteLoading ? <CircularProgress size="20px" style={{ color: "black" }} /> : "Löschen"}
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Button
                        variant="contained"
                        onClick={() => { dispatch(resetViewMode()) }}
                        color="default"
                        className={classes.showtriButton}
                    >
                        Schließen
                    </Button>
                </div>
            );
        else return (<React.Fragment />)
    }

    const [messstelleInputValue, setMessstelleInputValue] = React.useState('');

    function printEdit() {
        return (<Paper className={classes.paper} style={{ marginBottom: "10px", marginLeft: "24px", marginRight: "24px" }}>
            <form className={classes.root} noValidate autoComplete="off" style={{ marginTop: "10px", marginLeft: "24px", marginRight: "24px", marginBottom: "10px" }}>
                <div>
                    <Grid container spacing={4} >
                        <Grid item container xs={12}>
                            <Grid item md={3}>
                                <Typography component={"div"} variant="h6" color="primary" className={classes.typoH6Style}>
                                    {newEntry ? "Neue Störung anlegen" : "Bearbeiten von Störung: " + aktuelleStoerung.name}
                                </Typography>
                            </Grid>
                            <Grid item md={3} />
                            <Grid item md={6}>
                                {editEntry ? printSaveDiscardButtons() : printEditDeleteButton()}
                            </Grid>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <FormControl className={classes.fullWidth}>
                                <TextField
                                    required={true}
                                    id="stoerung-name" disabled={editEntry ? false : true}
                                    label="Störungsbezeichnung" variant="outlined"
                                    error={validate(dispatch, setError, resetError, aktuelleStoerung.name, "name")}
                                    helperText={validateHelper(aktuelleStoerung.name)}
                                    inputProps={{ maxLength: 100 }}
                                    onChange={(event) => dispatch(setName(event.target.value))} value={aktuelleStoerung.name} />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <FormControl className={classes.fullWidth}>
                                <Autocomplete
                                    id="select-messstelle"
                                    noOptionsText={<React.Fragment>
                                        {messstellenLoading && messstellenLoadingLookup ? <CircularProgress style={{ padding: "5px" }} /> : "Keine Messstelle"}
                                    </React.Fragment>}
                                    disabled={editEntry ? false : true}
                                    value={aktuelleStoerung.messstelle}
                                    onChange={(_, newValue) => {
                                        if (newValue) dispatch(setMessstelle(newValue));
                                    }}
                                    inputValue={messstelleInputValue}
                                    onInputChange={(event, newInputValue) => {
                                        setMessstelleInputValue(newInputValue);
                                    }}
                                    options={
                                        messstellen.map((x: messstelle) => x.name)}
                                    getOptionLabel={(option) => {
                                        //eslint-disable-next-line security/detect-object-injection
                                        const currentMessstelle = messstellenDict[option];
                                        if (currentMessstelle)
                                            return currentMessstelle.umspannwerk + ": " + currentMessstelle.schaltfeld + " (" + currentMessstelle.name + ")";
                                        return "";
                                    }}
                                    renderInput={(params) =>
                                        <TextField
                                            required={true}
                                            {...params}
                                            label="Messstelle"
                                            variant="outlined" />}

                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <FormControl className={classes.fullWidth}>
                                <MuiPickersUtilsProvider locale={de} utils={DateFnsUtils}>
                                    <KeyboardDateTimePicker
                                        id="stoerung-startzeit"
                                        format="dd.MM.yyyy HH:mm:ss"
                                        okLabel="OK"
                                        cancelLabel="ABBRECHEN"
                                        disabled={editEntry ? false : true}
                                        label="Startzeit"
                                        inputVariant="outlined"
                                        ampm={false}
                                        invalidDateMessage={"Das ausgewählte Datum hat ein ungültiges Format."}
                                        value={isUTC ? addTimezoneOffset(new Date(aktuelleStoerung.start)) : aktuelleStoerung.start}
                                        onChange={(event) => dispatch(setStartDatum(isUTC ? subtractTimezoneOffset(new Date(event + "")) : event))}
                                    />
                                </MuiPickersUtilsProvider>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <FormControl className={classes.fullWidth}>
                                <MuiPickersUtilsProvider locale={de} utils={DateFnsUtils}>
                                    <KeyboardDateTimePicker
                                        id="stoerung-endzeit"
                                        format="dd.MM.yyyy HH:mm:ss"
                                        okLabel="OK"
                                        cancelLabel="ABBRECHEN"
                                        disabled={editEntry ? false : true}
                                        label="Endzeit"
                                        inputVariant="outlined"
                                        ampm={false}
                                        minDate={aktuelleStoerung.start}
                                        minDateMessage={"Das ausgewählte Datum liegt vor der Startzeit."}
                                        invalidDateMessage={"Das ausgewählte Datum hat ein ungültiges Format."}
                                        value={isUTC ? addTimezoneOffset(new Date(aktuelleStoerung.ende)) : aktuelleStoerung.ende}
                                        onChange={(event) => dispatch(setEndDatum(isUTC ? subtractTimezoneOffset(new Date(event + "")) : event))}
                                    />
                                </MuiPickersUtilsProvider>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <FormControl className={classes.fullWidth}>
                                <TextField id="stoerung-kommentar" disabled={editEntry ? false : true}
                                    label="Kommentar" variant="outlined"
                                    multiline
                                    rows={5}
                                    rowsMax={5}
                                    onChange={(event) => dispatch(setKommentar(event.target.value))} value={aktuelleStoerung.kommentar} />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Typography component={"div"} variant="h6" color="primary" className={classes.typoH6Style}>Zugeordnete Störschriebe</Typography>
                            <div style={{ height: "20vh", width: '100%' }}>
                                <DataGrid
                                    disableColumnSelector={true}
                                    localeText={(deDE as LocalizationV4).props.MuiDataGrid.localeText}
                                    columns={stoerschrieblisteGridCols}
                                    rows={aktuelleStoerung.stoerschriebe ? aktuelleStoerung.stoerschriebe : []}
                                    sortModel={[
                                        {
                                            field: 'start',
                                            sort: 'desc',
                                        },
                                    ]} loading={stoerschrieblisteLoading} />
                            </div>
                        </Grid>
                        <Grid item xs={12} md={5}>
                            <Typography component={"div"} variant="h6" color="primary" className={classes.typoH6Style}>Zugeordnete Graphen</Typography>
                            <div style={{ height: "20vh", width: '100%' }}>
                                <DataGrid
                                    disableColumnSelector={true}
                                    localeText={(deDE as LocalizationV4).props.MuiDataGrid.localeText}
                                    columns={graphenGridCols}
                                    rows={newEntry || editEntry ? gespeicherteSuchen : aktuelleStoerung.graphen ? gespeicherteSuchen.filter(x => aktuelleStoerung.graphen.includes(x.id)) : []}
                                    sortModel={[
                                        {
                                            field: 'name',
                                            sort: 'asc',
                                        },
                                    ]} loading={graphenlisteLoading} onCellClick={(param: GridCellParams) => {
                                        if (param.field == "zugeordnet") return false;
                                        let tabData = emptyTab(1);
                                        const temp = gespeicherteSuchen.find(x => x.id == (param.row.id as number));
                                        if (temp)
                                            tabData = temp.wert;
                                        dispatch(loadGespeicherteSuche(tabData));
                                        history.push("/dashboardAnalyse");
                                    }} />
                            </div>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <Typography component={"div"} variant="h6" color="primary" className={classes.typoH6Style}>Anhänge</Typography>
                            <TableContainer className={classes.heightScrolledTable} >
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Name</TableCell>
                                            <TableCell style={!newEntry && !editEntry ? { display: "none" } : {}}>Aktion</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {anhanglisteLoading ? <CircularProgress size="20px" /> : aktuelleStoerung.anhaenge == null || aktuelleStoerung.anhaenge.length == 0 ?
                                            newEntry ? "" : <TableRow><TableCell colSpan={3}>Keine Anhänge</TableCell></TableRow> :
                                            aktuelleStoerung.anhaenge.map((e, i) => (
                                                <TableRow key={i}>
                                                    <TableCell><Link href="#" target="_blank" rel="noopener" onClick={(ev: React.MouseEvent) => { ev.preventDefault(); dispatch(getAnhang(e)); }}>{e.name}</Link></TableCell>
                                                    <TableCell><Button style={!newEntry && !editEntry ? { display: "none" } : {}} onClick={() => dispatch(deleteAnhang(e))}><Delete /></Button></TableCell>
                                                </TableRow>
                                            ))}
                                        <TableRow style={!newEntry && !editEntry ? { display: "none" } : {}}>
                                            {isAuthorized([rollen.admin, rollen.technik, rollen.netzwirtschaft]) ?
                                                <TableCell colSpan={3}>
                                                    {!newEntry ? <Button variant="contained" color="secondary" onClick={() => setOpenFileUploadDialog(true)}>Anhang hinzufügen</Button> : "Bitte speichern Sie die Störung, um Anhänge hinzuzufügen."}
                                                    <Dialog
                                                        open={openFileUploadDialog}
                                                        onClose={() => setOpenFileUploadDialog(false)}
                                                    >
                                                        <DialogTitle>Anhang hinzufügen</DialogTitle>
                                                        <DialogContent>
                                                            <DialogContentText>
                                                                Bitte wählen Sie die hochzuladende Datei aus.
                                                            </DialogContentText>
                                                            <Typography>{selectedFile?.name}</Typography><Button variant="contained" component="label">Datei auswählen<input type="file" hidden onChange={(event) => selectFile(event)} /></Button><br />
                                                        </DialogContent>
                                                        <DialogActions>
                                                            <Button
                                                                color="secondary"
                                                                variant="contained"
                                                                onClick={() => { setOpenFileUploadDialog(false); setSelectedFile(null); }}
                                                                className={classes.cancleDeleteButton}
                                                            >
                                                                Abbrechen
                                                            </Button>
                                                            <Button
                                                                color="secondary"
                                                                variant="contained"
                                                                disabled={!selectedFile}
                                                                onClick={() => uploadSelectedFile()}
                                                                style={{ minWidth: "120px", minHeight: "36px" }}

                                                            >
                                                                {anhanglisteLoading ? <CircularProgress size="20px" style={{ color: "black" }} /> : "Hinzufügen"}
                                                            </Button>
                                                        </DialogActions>
                                                    </Dialog>
                                                </TableCell>
                                                : ""}
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                </div>
            </form>
        </Paper >)
    }

    return (
        <div>
            <Container maxWidth={false} style={{ marginTop: "10px" }}>
                <Grid container md={12} spacing={2} style={{ marginBottom: "10px" }}>
                    <Grid item md={3} />
                    <Grid item md={6}>
                        <Typography color="primary" variant="h5">
                            Störungsmanagement
                        </Typography>
                    </Grid>
                </Grid>
            </Container>
            {viewMode ? printEdit() : ""}
            <Paper className={classes.paper} style={{ marginLeft: "24px", marginRight: "24px" }}>
                <Grid container spacing={2} style={{ marginBottom: "20px", padding: "0px", paddingRight: "16px" }}>
                    <Grid item md={3} >
                        <Typography color="primary" variant="h6" className={classes.typoH6Style} style={{ marginLeft: "20px" }} >
                            Übersicht Störungen
                        </Typography>
                    </Grid>
                    <Grid item md={3} />
                    <Grid item md={2} />
                    <Grid item md={2} />
                    <Grid item md={2} style={{ paddingRight: "24px", paddingTop: "0px" }}>
                        {isAuthorized([rollen.admin, rollen.technik, rollen.netzwirtschaft]) ?
                            <Button
                                variant="contained"
                                onClick={() => dispatch(startNewEntry())}
                                color="secondary"
                                className={classes.showButton}
                                disabled={editEntry}
                            >
                                Neue Störung
                            </Button> : ""}
                    </Grid>

                    {printTable(stoerungsliste)}

                </Grid>
            </Paper>
        </div>
    )
}

